import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFindCompanyByCode } from './useFindCompanyByCode';

import { useQueryParam } from '@utils/hooks/useQueryParam';

import { getPath } from '@services/RouteService/paths';

import { useReactiveVar } from '@apollo/client';
import { authVar, redirectUnloggedUser } from '@boot/reactiveVariables';

export const useCompanyCodeRedirect = () => {
    const navigate = useNavigate();

    const { isLoggedIn } = useReactiveVar(authVar);

    const [findCompanyByCode, { data, loading }] = useFindCompanyByCode();

    const companyCode = useQueryParam('companyCode');
    const surveyUuid = useQueryParam('surveyUuid');
    const disclosureUuid = useQueryParam('disclosureUuid');
    const responseUuid = useQueryParam('responseUuid');

    const tenantData = data?.tenant;

    const [customUrlLoading, setCustomUrlLoading] = useState(!!companyCode);

    useEffect(() => {
        if (companyCode && !isLoggedIn) {
            void findCompanyByCode({
                onError: () => {
                    setCustomUrlLoading(false);
                },
                variables: {
                    companyCode,
                },
            });
        }
    }, [companyCode, isLoggedIn]);

    useEffect(() => {
        if (tenantData || isLoggedIn) {
            if (surveyUuid) {
                isLoggedIn
                    ? navigate(
                          getPath({
                              params: { surveyId: surveyUuid },
                              path: '/survey/details/:surveyId',
                          }),
                      )
                    : redirectUnloggedUser({
                          params: {
                              surveyId: surveyUuid,
                          },
                          path: '/survey/details/:surveyId',
                      });
            } else if (disclosureUuid && responseUuid) {
                isLoggedIn
                    ? navigate(
                          getPath({
                              params: {
                                  disclosureUuid: disclosureUuid,
                                  submissionUuid: responseUuid,
                              },
                              path: '/disclosure/list/:disclosureUuid/:submissionUuid',
                          }),
                      )
                    : redirectUnloggedUser({
                          params: {
                              disclosureUuid: disclosureUuid,
                              submissionUuid: responseUuid,
                          },
                          path: '/disclosure/list/:disclosureUuid/:submissionUuid',
                      });
            } else if (disclosureUuid) {
                isLoggedIn
                    ? navigate(
                          getPath({
                              params: {
                                  disclosureUuid: disclosureUuid,
                              },
                              path: '/disclosure/details/:disclosureUuid',
                          }),
                      )
                    : redirectUnloggedUser({
                          params: {
                              disclosureUuid,
                          },
                          path: '/auth/declare-credentials/:disclosureUuid',
                      });
            } else {
                if (!isLoggedIn) navigate(getPath({ path: '/' }));
            }

            setCustomUrlLoading(false);
        }
    }, [tenantData, isLoggedIn]);

    return { companyCodeLoading: customUrlLoading || loading };
};
